import { ofos } from './ofos';
import type { OfoType } from '@/hooks/use-ofo-status';

export function OfoIcon({ ofo }: { ofo: OfoType }) {
  const OfoIcon = ofos[ofo]?.icon ?? null;

  return <OfoIcon />;
}
